import React from 'react'
import ContributeForm from '../../views/ContributePage/ContributeForm.js'
import ContributeBalance from '../../views/ContributePage/ContributeBalance.js'
import ContributeInfo from './ContributeInfo.js'
import ContributeContract from '../../views/ContributePage/ContributeContract.js'
import PropTypes from 'prop-types'
import TransactionHistory from './TransactionHistory.js'
import TransactionRefHistory from './TransactionRefHisotry.js'
import ContributeTopRewards from './ContributeTopRewards/ContributeTopRewards.js'
import { useGetUserInfoQuery } from 'hooks/useGetUserInfoQuery.js'
import RoundView from 'components/RoundView/RoundView.js'

export default function ContributePage(props) {
	const { data: userInfo } = useGetUserInfoQuery()
	const { isWhiteList, isCoreTeam, address } = userInfo || {}

	// useEffect(() => {
	// 	if (isPause) {
	// 		dispatch(openModalMaintenanceAction())
	// 	} else {
	// 		dispatch(closeModalMaintenanceAction())
	// 	}
	// }, [isPause])

	const canContribute = isWhiteList || isCoreTeam

	return (
		<div>
			<div className='row'>
				<div className='col-12 mb-4'>
					<RoundView />
				</div>
				<div className='col-12 col-md-6 mb-4'>
					<ContributeInfo />
				</div>
				<div className='col-12 col-md-6 mb-4'>
					<ContributeBalance isConnect={props.isConnect} />
				</div>
				{isCoreTeam && (
					<div className=' col-12 mb-4'>
						<div className='header-notification d-flex'>
							<svg
								width='20'
								height='20'
								viewBox='0 0 20 20'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M9.99984 9.16667C9.77883 9.16667 9.56687 9.25447 9.41059 9.41075C9.25431 9.56703 9.16651 9.77899 9.16651 10V13.3333C9.16651 13.5544 9.25431 13.7663 9.41059 13.9226C9.56687 14.0789 9.77883 14.1667 9.99984 14.1667C10.2209 14.1667 10.4328 14.0789 10.5891 13.9226C10.7454 13.7663 10.8332 13.5544 10.8332 13.3333V10C10.8332 9.77899 10.7454 9.56703 10.5891 9.41075C10.4328 9.25447 10.2209 9.16667 9.99984 9.16667ZM10.3165 5.90001C10.1136 5.81666 9.88606 5.81666 9.68317 5.90001C9.58088 5.93967 9.48743 5.99914 9.40817 6.07501C9.33457 6.15601 9.27538 6.24902 9.23317 6.35001C9.18652 6.4489 9.16369 6.55736 9.16651 6.66667C9.16587 6.77634 9.18689 6.88506 9.22837 6.98659C9.26984 7.08813 9.33094 7.18047 9.40817 7.25834C9.48918 7.33195 9.58219 7.39114 9.68317 7.43334C9.80942 7.48521 9.94648 7.50527 10.0823 7.49177C10.2181 7.47826 10.3485 7.43161 10.4621 7.3559C10.5757 7.28019 10.6689 7.17774 10.7336 7.05756C10.7983 6.93739 10.8325 6.80316 10.8332 6.66667C10.8301 6.44603 10.7438 6.2347 10.5915 6.07501C10.5123 5.99914 10.4188 5.93967 10.3165 5.90001ZM9.99984 1.66667C8.35166 1.66667 6.7405 2.15541 5.37009 3.07109C3.99968 3.98677 2.93158 5.28826 2.30084 6.81098C1.67011 8.33369 1.50509 10.0092 1.82663 11.6258C2.14817 13.2423 2.94185 14.7271 4.10728 15.8926C5.27272 17.058 6.75758 17.8517 8.37409 18.1732C9.9906 18.4948 11.6662 18.3297 13.1889 17.699C14.7116 17.0683 16.0131 16.0002 16.9288 14.6298C17.8444 13.2593 18.3332 11.6482 18.3332 10C18.3332 8.90566 18.1176 7.82202 17.6988 6.81098C17.28 5.79993 16.6662 4.88127 15.8924 4.10745C15.1186 3.33363 14.1999 2.7198 13.1889 2.30101C12.1778 1.88222 11.0942 1.66667 9.99984 1.66667ZM9.99984 16.6667C8.6813 16.6667 7.39237 16.2757 6.29604 15.5431C5.19971 14.8106 4.34523 13.7694 3.84064 12.5512C3.33606 11.3331 3.20404 9.99261 3.46127 8.6994C3.71851 7.4062 4.35345 6.21831 5.2858 5.28596C6.21815 4.35361 7.40603 3.71867 8.69924 3.46144C9.99245 3.2042 11.3329 3.33622 12.5511 3.84081C13.7692 4.34539 14.8104 5.19988 15.543 6.2962C16.2755 7.39253 16.6665 8.68146 16.6665 10C16.6665 11.7681 15.9641 13.4638 14.7139 14.7141C13.4636 15.9643 11.768 16.6667 9.99984 16.6667Z'
									fill='white'
								/>
							</svg>
							<p className='heading-100'>
								Bạn đang đóng góp theo{' '}
								<span style={{ textDecoration: 'underline' }}>
									chính sách nhân viên nội bộ
								</span>
							</p>
						</div>
					</div>
				)}
				<div className='col-12'>{canContribute && <ContributeForm />}</div>
				<ContributeTopRewards address={address} />
				{props.isConnect ? (
					<>
						<div className='col-12 mt-4'>
							<TransactionRefHistory />
						</div>
						<div className='col-12 mt-4'>
							<TransactionHistory />
						</div>
					</>
				) : (
					''
				)}

				<div className='col-12'>
					<ContributeContract />
				</div>
			</div>
		</div>
	)
}

ContributePage.propTypes = {
	isConnect: PropTypes.any,
}
